import React, { useState } from 'react';

//style
import './style.scss';

import ProjectModal from '../ProjectModal';

export default function ProjectBox({
  name,
  details,
  createdWith,
  projectImage,
  alt,
  gitlink,
  live,
}) {
  let [active, setActive] = useState(false);

  const handleClose = () => {
    setActive(false);
    document.querySelector('.overlay').style.display = 'none';
  };

  document.querySelector('.overlay').onclick = () => {
    setActive(false);
    document.querySelector('.overlay').style.display = 'none';
  };

  const onClick = () => {
    setActive((prev) => !prev);
    document.querySelector('.overlay').style.display = 'block';
  };

  return (
    <>
      <div className="project-box" onClick={onClick}>
        <div className="box-container">
          <div className="box-img">
            <img
              loading="lazy"
              src={`https://portfolio-backend-tousif.herokuapp.com/images/${projectImage}`}
              alt={alt}
            />
          </div>
          <div className="box-title">{name}</div>
          <div className="box-desc">
            {details && details.length > 70
              ? details.substring(0, 70) + '....'
              : details}
          </div>
          <div className="created-with">
            {createdWith.map((language) => (
              <p className="language" key={language._id}>
                {language.language}
              </p>
            ))}
          </div>
        </div>
      </div>
      <ProjectModal
        name={name}
        details={details}
        projectImage={projectImage}
        active={active}
        alt={alt}
        gitlink={gitlink}
        live={live}
        createdWith={createdWith}
        onClick={handleClose}
      />
    </>
  );
}
